import ResponsiveImage from "@components/atoms/image/ResponsiveImage";

type FoldData = {
  image: {
    alt: string;
    path: string;
    align: string;
  };
  heading: string;
  desc: string[];
  quote: string;
};

type SecondFoldProps = {
  data: FoldData[];
};

export default function SecondFold({ data }: SecondFoldProps) {
  const Description = ({ data }) => {
    return data.map((item, count) => {
      return (
        <p
          className={`${count > 0 ? "lg:mt-1.5 md:mt-1.5" : ""}`}
          dangerouslySetInnerHTML={{ __html: item }}
          key={count}
        />
      );
    });
  };

  const ImageLeft = ({ data }) => {
    return (
      <div className="container">
        <div className="grid--default has-align-top">
          <ResponsiveImage
            dpi="@2x"
            mobile="crop"
            wrapClass="lg:maxw-lg"
            imgClass="imgholder-primary"
            alt={data.image.alt}
            src={data.image.path}
          />{" "}
          <article className="text-left lg:maxw-md">
            <h2
              className="text-lg lg:mb-3 md:mb-2 md:mt-5"
              dangerouslySetInnerHTML={{ __html: data.heading }}
            />
            <Description data={data.desc} />
          </article>
        </div>
        <div className="lg:mt-10 md:mt-5 lg:ml-auto lg:maxw-md lg:d-fx">
          <span className="apostrophe">&#8220;</span>
          <blockquote className="lg:ml-3 text-sm fs-italic md:-mt-4.5">
            {data.quote}
          </blockquote>
        </div>
      </div>
    );
  };

  const ImageRight = ({ data }) => {
    return (
      <div className="container lg:mt-15 md:mt-10">
        <div className="grid--default has-align-top md:fx md:fx--w">
          <article className="text-left lg:maxw-md fx--o-2">
            <h2
              className="text-lg lg:mb-3 md:mb-2 md:mt-5"
              dangerouslySetInnerHTML={{ __html: data.heading }}
            />
            <Description data={data.desc} />
          </article>{" "}
          <ResponsiveImage
            dpi="@2x"
            mobile="crop"
            wrapClass="lg:maxw-lg"
            imgClass="imgholder-primary"
            alt={data.image.alt}
            src={data.image.path}
          />
        </div>
        {data.quote.length !== 0 ? (
          <div className="lg:mt-10 md:mt-5 lg:maxw-md lg:d-fx">
            <span className="apostrophe">&#8220;</span>
            <blockquote className="lg:ml-3 text-sm fs-italic md:-mt-4.5">
              {data.quote}
            </blockquote>
          </div>
        ) : (
          ""
        )}
      </div>
    );
  };

  return (
    <section className="bg-light lg:pt-10 lg:pb-10 md:pt-5 md:pb-5 info-section">
      {data.map((item, count) => {
        return item.image.align === "left" ? (
          <ImageLeft data={item} key={count} />
        ) : (
          <ImageRight data={item} key={count} />
        );
      })}
    </section>
  );
}
